// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validateArgentineCity(cityValue: string): ?UserInputValidationError {
  return cityValue && cityValue.length > 0 ? VALID : { id: 'empty' };
}
